import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import { AIPlatformAPI } from 'api/index'

export interface ICategoryOption {
  categoryId: string
  label: string
  value: string
}

type Category = {
  categoryId: string
  name: string
  description: string
  exposed: boolean
}

export enum CategoryType {
  PRODUCT = 'Product',
  COMPANY_AND_LEADERSHIP = 'Company and Leadership',
  EVENTS = 'Events',
  CAREERS = 'Careers',
  TECHNICAL_INQUIRIES = 'Technical inquiries',
  SERVICES = 'Services',
  PRICING = 'Pricing',
  GUARDRAILS = 'Guardrails',
  SMALL_TALK = 'Small Talk',
  UNCATEGORIZED = 'Uncategorized',
}

export const useExposedCategories = (enabled = true) => {
  const { data: categories = [] } = useQuery<Category[]>({
    queryKey: ['exposedCategories'],
    queryFn: async () => {
      try {
        const response = await AIPlatformAPI.get<Category[]>(
          'api/category_insights/categories'
        )
        return response.data
      } catch (error) {
        console.error('Error fetching categories:', error)
        throw error
      }
    },
    staleTime: 60000,
    enabled: enabled,
  })

  const exposedCategoryOptions: ICategoryOption[] = useMemo(() => {
    return categories
      .sort((a, b) => Number(a.categoryId) - Number(b.categoryId))
      .map((category) => ({
        categoryId: category.categoryId,
        label: category.name,
        value: String(category.categoryId),
      }))
  }, [categories])

  return exposedCategoryOptions
}

export default useExposedCategories
